
declare const $;
export function backdropBasket_directive($compile) {
    "ngInject";

    var directive = {
        link: link,
        restrict: 'A',
        scope:{
            isOpen:"="
        }
    };
    return directive;

    function link(scope, element, attrs) {
        var temp = "<div class='cart-backdrop' ng-show='isOpen' ng-click='isOpen=false'></div>"
        var editTemp = $compile(temp)(scope)
        $(element).append(editTemp)
    }
}


function ControllerController() {

}



// WEBPACK FOOTER //
// ./src/directives/backdrop-basket/backdrop-basket.ts